import { mockBrandRetailer } from '@domgen/dgx-fe-catalogue';
import { startOfToday } from 'date-fns';
import { ApplianceDetailsFormValue } from '../../models/appliance-details/appliance-details-form-value.type';

export const mockApplianceDetailsFormValue: ApplianceDetailsFormValue = {
  applianceCode: 'CN',
  brandCode: 'AEG',
  modelNumber: null,
  partsWarranty: null,
  purchaseDate: startOfToday(),
  purchasePrice: 300,
  retailer: mockBrandRetailer.name,
  serialNumber: null,
  warranty: 12,
};
